import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';
import type { AutomationLimitAwarenessBanner as AutomationLimitAwarenessBannerType } from './banner.tsx';

export const AutomationLimitAwarenessBanner = lazyAfterPaint<
	typeof AutomationLimitAwarenessBannerType
>(
	() =>
		import(/* webpackChunkName: "async-automation-limit-awareness-banner" */ './banner.tsx').then(
			(module) => module.AutomationLimitAwarenessBanner,
		),
	// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
	{ ssr: true, entryFsSsrLiftImportToModule: true, includeInShellOnlySsrBundle: true },
);

export const AutomationLimitAwarenessBannerAsync = () => {
	if (fg('upsell_jira_global_automations_limit_banner_fg')) {
		return (
			<Placeholder name="async-automation-limit-awareness-banner" fallback={null}>
				<AutomationLimitAwarenessBanner />
			</Placeholder>
		);
	}
};
